import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { ASPECT_RATIOS } from './constants';

interface AspectRatioGridProps {
  /** Preset value, or null = Original (full image), or undefined = no selection (custom crop). */
  selectedRatio: number | null | undefined;
  onSelect: (ratio: number | null) => void;
}

function AspectRatioIcon({ iconBoxClass }: { iconBoxClass: string }) {
  if (!iconBoxClass) return null;

  return (
    <div className="flex size-5 items-center justify-start">
      <div className={cn('border border-current shrink-0', iconBoxClass)} />
    </div>
  );
}

export function AspectRatioGrid({ selectedRatio, onSelect }: AspectRatioGridProps) {
  return (
    <div className="grid grid-cols-2 gap-x-3 gap-y-2">
      {ASPECT_RATIOS.map((option) => {
        const isSelected = selectedRatio === option.value;

        return (
          <Button
            variant="outline"
            colorScheme={isSelected ? 'primary' : 'secondary'}
            key={option.label}
            type="button"
            onClick={() => onSelect(option.value)}
            className={cn(isSelected && 'border-primary')}
          >
            <AspectRatioIcon iconBoxClass={option.iconBoxClass} />
            {option.label}
          </Button>
        );
      })}
    </div>
  );
}
